import {
  useAccount,
  useEstimateGas as useWagmiEstimateGas,
  // useGasPrice,
} from 'wagmi';
import { GAS_ESTIMATE_MULTIPLIER } from 'src/constants';
import BigNumber from 'bignumber.js';

export function useEstimateGas({
  encodedData,
  toAddress,
  value,
  claimCount = 0,
  enabled = true,
}: {
  encodedData?: `0x${string}`;
  toAddress: `0x${string}`;
  value?: bigint;
  claimCount?: number;
  enabled?: boolean;
}) {
  const { address } = useAccount();

  const { data: gasEstimate, isLoading: isLoadingGasEstimate } =
    useWagmiEstimateGas({
      data: encodedData,
      to: toAddress,
      value,
      query: {
        enabled: !!address && !!encodedData && enabled,
      },
    });

  const { data: gasPrice, isLoading: isLoadingGasPrice } = {
    data: 52_000_000_000n, // hardcode 52 gwei for monad for now
    isLoading: false,
  }; //useGasPrice();

  const transactionCost = BigNumber(String(gasEstimate || 0))
    .times(String(gasPrice || 0))
    .times(GAS_ESTIMATE_MULTIPLIER);

  return {
    transactionCost,
    gasLimit:
      typeof gasEstimate === 'undefined' ||
      BigNumber(String(gasEstimate)).gte(52_500_000)
        ? BigInt(200_000 + claimCount * 50_000)
        : gasEstimate,
    originalGasEstimate: gasEstimate,
    isLoadingTransactionCost: isLoadingGasEstimate || isLoadingGasPrice,
  };
}
